export class Model {
    id: string
    name: string
    key: string
    category: string
    createTime: any
    lastUpdateTime: any
    version: number
    metaInfo: string
    deploymentId: string
    editorSourceValueId: string
    editorSourceExtraValueId: string
    tenantId: string
}